import { render } from "./PaymentRedirectView.vue?vue&type=template&id=270ac7d7"
import script from "./PaymentRedirectView.vue?vue&type=script&lang=js"
export * from "./PaymentRedirectView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__